import { Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "../../common/api-endpoints";
import {
  AdminManageQaDto,
  FindManageQaDto,
  CreateManageQaDto,
  UpdateManageQaDto,
} from "../../dto/governance-admin/manage-qa.dto";
import { PageResultDto } from "../../dto/page-result.dto";

@Injectable({
  providedIn: "root",
})
export class AdminManageQaService {
  constructor(private readonly httpService: HttpService) {}

  public async find(
    params: FindManageQaDto = {}
  ): Promise<PageResultDto<AdminManageQaDto>> {
    const queryParams: any = {};

    if (params.limit) queryParams.limit = params.limit.toString();
    if (params.offset) queryParams.offset = params.offset.toString();
    if (params.question) queryParams.question = params.question;
    if (params.answer) queryParams.answer = params.answer;
    if (params.mallId) queryParams.mallId = params.mallId;

    return await this.httpService.get<PageResultDto<AdminManageQaDto>>(
      ADMIN_API_ENDPOINTS.CHATBOT,
      queryParams
    );
  }

  public async findById(id: string): Promise<AdminManageQaDto> {
    return await this.httpService.get<AdminManageQaDto>(
      `${ADMIN_API_ENDPOINTS.CHATBOT}/${id}`
    );
  }

  public async create(data: CreateManageQaDto): Promise<AdminManageQaDto> {
    return await this.httpService.post<AdminManageQaDto>(
      ADMIN_API_ENDPOINTS.CHATBOT,
      data
    );
  }

  public async update(
    id: string,
    data: UpdateManageQaDto
  ): Promise<AdminManageQaDto> {
    return await this.httpService.put<AdminManageQaDto>(
      `${ADMIN_API_ENDPOINTS.CHATBOT}/${id}`,
      data
    );
  }

  public async delete(id: string): Promise<boolean> {
    await this.httpService.delete(`${ADMIN_API_ENDPOINTS.CHATBOT}/${id}`);
    return true;
  }
}
